var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.445,
    height: 20.445,
    viewBox: "0 0 20.445 20.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "usdt-crypto-cryptocurrency-cryptocurrencies-cash-money-bank-payment_95165",
    d: "M10.223,20.445A10.223,10.223,0,1,1,20.445,10.223,10.222,10.222,0,0,1,10.223,20.445ZM11.451,8.813V7.3H14.91V5H5.491V7.3H8.951V8.812c-2.811.129-4.925.686-4.925,1.353s2.114,1.224,4.925,1.353v4.844h2.5V11.517c2.807-.129,4.916-.686,4.916-1.352s-2.109-1.223-4.916-1.353Zm0,2.294h0c-.07.005-.433.027-1.241.027-.645,0-1.1-.019-1.259-.027v0C6.466,11,4.612,10.565,4.612,10.048S6.466,9.1,8.951,8.987v1.689c.162.012.627.039,1.27.039.771,0,1.158-.032,1.23-.038V8.988c2.479.111,4.329.543,4.329,1.059s-1.85.949-4.329,1.059Z",
    fill: "#fcfcfc",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.191facad9ba32f2dde8eea540c08ea45.svg";
export { ForwardRef as ReactComponent };